export default __webpack_public_path__ + "static/media/industry.32b9e662.svg";